// extracted by mini-css-extract-plugin
export default {"containerOutside":"_4ecxuWDSkc5eok57zBCsMO","containerInside":"_4m7BPHdZVSZRnXAeUg8XqR","heading":"_19ifBAST3NZYWeHCGxUZ8M"};